// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jSKO","newExpiryDate":"styles_newExpiryDate__3iRjr","footer":"styles_footer__3p1s4"};